export const NEW_SITE_ROUTE_KEY = "draft";
